import { OrderSyncTriggerEventType } from './events';

export enum IntegrationFormat {
  SCNG_ADBASE = 'SCNG_ADBASE'
}

export type IntegrationTriggers = Partial<
  Record<OrderSyncTriggerEventType, boolean>
>;

export type IntegrationSettings = {
  /**
   * A human readable identifier for the integration settings.
   */
  name: string;

  /**
   * Used to determine which integration script to use.
   */
  format: IntegrationFormat;

  /**
   * The order sync trigger event types that should kick off an integration
   * attempt.
   */
  triggers: IntegrationTriggers;
};
